import React, { useContext } from "react";
import styles from './ChatMessages.module.sass'
import ChatMessage from "../ChatMessage";
import { ChatContext } from "../../../contexts/ChatContext";
import { UserContext } from "../../../contexts/UserContext";
import ChatShare from "../ChatShare";
import cn from 'classnames';

const ChatMessages = ({}) => {

    const chatContext = useContext( ChatContext );
    const userContext = useContext( UserContext );

    function checkIfIsLastMessage( index ,data ){

        if( index == 0 ) return true;
        if( chatContext.messages[index - 1].avatarID != data.avatarID ) return true;

        return false;

    }

    function isToday(dateToCompare){
        const today = new Date()
        return dateToCompare.getDate() == today.getDate() &&
        dateToCompare.getMonth() == today.getMonth() &&
        dateToCompare.getFullYear() == today.getFullYear()
    }

    return <div className={styles.container}>
        { chatContext.messages && chatContext.messages.map( ((message,index) => {
        
            const isME = message.avatarID == userContext.userData.avatarID;
            const isOwnLastMessage = checkIfIsLastMessage(index,message);
            const isLastMessage = index==0;
            const showAvatar = isOwnLastMessage && !isLastMessage && styles.ownLastMessage;
            let component;

            let date = new Date( message.timestamp );
            message.dateString = isToday(date) ? 'Today ' + date.toLocaleTimeString(undefined,{timeStyle: 'short'}) : date.toLocaleString(undefined, {dateStyle: 'short', timeStyle: 'short'});

            if( !message.metadata ) component = <ChatMessage data={message} isOwnLastMessage={isOwnLastMessage}/>
            else component = <ChatShare data={message} isOwnLastMessage={isOwnLastMessage}/>

            return <div key={index} className={cn(styles.message, isME && styles.mine, showAvatar && styles.showAvatar)}>{component}</div>

        }) ) }
    </div>

};

export default ChatMessages;
